import { AspectRatio, Heading, Text, Skeleton } from "@chakra-ui/react";
import React, { useState } from "react";
import PageWrapper from "../Common/PageWrapper";

const CalendarPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  return (
    <PageWrapper>
      <Heading mb={12}>Kalenteri</Heading>
      <Text maxW="1200px" mb={8}>
        Kalenterista näet veteraanitalon tämän hetkiset varaukset. Jos haluat
        varata talon käyttöösi, ota yhteyttä yhteystiedot -sivun kautta.
      </Text>

      {loading && (
        <AspectRatio w={{ base: "100vw", md: "800px" }} ratio={4 / 3}>
          <Skeleton />
        </AspectRatio>
      )}
      <AspectRatio w={{ base: "100vw", md: "800px" }} ratio={4 / 3}>
        <iframe
          title="Kalenteri"
          src="https://calendar.google.com/calendar/embed?height=600&wkst=2&bgcolor=%23ffffff&ctz=Europe%2FHelsinki&showTz=0&showCalendars=0&showTabs=1&showPrint=0&showDate=1&showNav=1&showTitle=1&src=Y2QzZWI2NTQ3OTYxM2M1NTM4MDM1OTczOGRmZjk0YTc5MzQ3ZDY2NWM0YWQ5ZDY4MjlmNDkwNzM2Njg0NDA3ZUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D50000"
          style={{ border: "none", display: loading ? "none" : "block" }}
          onLoad={() => setLoading(false)}
        />
      </AspectRatio>
    </PageWrapper>
  );
};
export default CalendarPage;
